export const ACTIVITY_AUDIENCE_TYPES = {
    TEAM: 1,
    ATHLETE: 2,
    NEW_ATHLETES: 3
};



// WEBPACK FOOTER //
// ./src/v5/home/lib/constants.js